import { FC, ReactElement, ReactNode, useEffect, useState } from 'react';
import { AlertBar, ImportantNote, StatusBar } from '@digital-pulse/react';
import useAlertProvider from './useAlertProvider';

import styles from './alert.module.scss';

interface AlertProps {
  title?: ReactNode;
  children?: ReactNode;
  footerContent: ReactNode;
  error?: boolean;
  info?: boolean;
}

const Alert: FC<AlertProps> = ({
  title,
  children,
  footerContent,
  error = true,
  info = false
}): ReactElement => {
  const { alerts } = useAlertProvider();
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey(key + 1);
  }, [alerts]);

  if (!error) {
    return (
      <StatusBar
        className={styles.alert_container}
        has-focus="true"
        key={key}
        renderHeading={title && <h2 slot="heading">{title}</h2>}
        renderFooter={footerContent && <div slot="footer">{footerContent}</div>}
      >
        <div className={styles.alert__description}>{children}</div>
      </StatusBar>
    );
  }

  if (info) {
    return (
      <ImportantNote
        className={styles.info_container}
        has-focus="true"
        has-close="false"
        key={key}
        renderHeading={title && <h2>{title}</h2>}
        renderFooter={footerContent && <div slot="footer">{footerContent}</div>}
      >
        {children && <div className={styles.alert__description}>{children}</div>}
      </ImportantNote>
    );
  }
  return (
    <AlertBar
      className={styles.alert_container}
      has-focus="true"
      key={key}
      renderHeading={title && <h2 className={styles.alert__title}>{title}</h2>}
      renderFooter={footerContent}
    >
      <div className={styles.alert__description}>{children}</div>
    </AlertBar>
  );
};

export default Alert;
